/**
 * Handles the flow of the day input in terms of formatting.
 */
export default function getFormattedDay(
	input: string,
	lastDayOfTheMonth: number = 31,
) {
	if (input === '00') return '0';
	const firstDigitOfLastMonth = parseInt(
		lastDayOfTheMonth.toString().charAt(0),
	);
	const inputAsNumber = parseInt(input);
	if (inputAsNumber <= firstDigitOfLastMonth) return input;
	if (inputAsNumber > firstDigitOfLastMonth && inputAsNumber < 10)
		return input.length === 2 ? input : '0' + input;
	if (inputAsNumber <= lastDayOfTheMonth) return input;
	return '';
}
